import Layout from '../../components/Layout';
import SectionHeading from '../../components/SectionHeading';
import { useSiteContent } from '../../content/ContentContext';

export default function GalleryPage() {
  const {
    content: { galleryImages, site },
  } = useSiteContent();

  return (
    <Layout>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <SectionHeading eyebrow="Gallery" title={site.galleryTitle} description={site.galleryDescription} center />
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {galleryImages.map((image) => (
            <figure key={image.src} className="overflow-hidden rounded-[1.75rem] bg-white shadow-sm">
              <img src={image.src} alt={image.alt} className="h-80 w-full object-cover transition duration-300 hover:scale-105" />
            </figure>
          ))}
        </div>
      </section>
    </Layout>
  );
}
